export default {
  EFA: "EFA",
  FMV: "FMV"
};
